import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

const input = "w-full border border-linen bg-white px-4 py-3 text-sm outline-none focus:border-pitch transition-colors";

export default function Contact() {
  const [info, setInfo] = useState({});
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "", honeypot: "" });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => { api.get("/content/contact").then((r) => setInfo(r.data.data || {})).catch(() => {}); }, []);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await api.post("/contact", form); setSent(true); toast.success("Your enquiry has been received."); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="luxy-container py-16 sm:py-24">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
        <div>
          <p className="eyebrow mb-3">Get in Touch</p>
          <h1 className="font-serif text-4xl sm:text-5xl text-pitch tracking-tight mb-6">Contact Concierge</h1>
          <p className="text-charcoal/80 leading-relaxed mb-10">For enquiries about a specific piece, sourcing requests, or private viewings, our team is here to assist.</p>
          <div className="space-y-6 text-sm">
            <div><div className="eyebrow mb-1">Email</div><div className="text-charcoal">{info.email || "concierge@luxyreign.com"}</div></div>
            <div><div className="eyebrow mb-1">Phone</div><div className="text-charcoal">{info.phone || "+61 (0) 000 000 000"}</div></div>
            <div><div className="eyebrow mb-1">Business Hours</div><div className="text-charcoal">{info.hours || "Monday–Friday, 9am–5pm AEST"}</div></div>
            <div><div className="eyebrow mb-1">Social</div><div className="text-charcoal">{info.instagram || "@luxyreign"}</div></div>
          </div>
          {info.note && <p className="text-xs text-stonemuted mt-8 font-mono uppercase tracking-widest">{info.note}</p>}
        </div>
        <div>
          {sent ? (
            <div className="bg-emeraldauth/10 border border-emeraldauth/30 p-8 text-center" data-testid="contact-sent">
              <p className="font-serif text-2xl text-pitch">Thank you</p>
              <p className="text-sm text-charcoal/70 mt-2">Your enquiry has been received. A member of our team will respond shortly.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <input type="text" tabIndex={-1} autoComplete="off" value={form.honeypot} onChange={(e) => setForm({ ...form, honeypot: e.target.value })} className="hidden" aria-hidden />
              <input required placeholder="Full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={input} data-testid="contact-name" />
              <input required type="email" placeholder="Email address" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={input} data-testid="contact-email" />
              <input placeholder="Subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className={input} data-testid="contact-subject" />
              <textarea required placeholder="Your message" rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className={input} data-testid="contact-message" />
              <button type="submit" disabled={loading} data-testid="contact-submit"
                className="w-full bg-pitch text-ivory text-xs font-mono uppercase tracking-[0.2em] py-4 hover:bg-charcoal transition-colors disabled:opacity-50">
                {loading ? "Sending…" : "Send Enquiry"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
